var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a',{staticClass:"link-block w-inline-block",on:{"click":_vm.resendCode}},[_c('h3',{staticClass:"resend-h3",class:{'white': !_vm.isReattempt }},[_vm._v(_vm._s(_vm.resendTitle)+" "+_vm._s(_vm.countDownTitle))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }